module.exports = __webpack_public_path__ + "b9471ad87795a275ebe4ddb48d6ead0e.png";